export const renderAgendaDate = (value: string | null | undefined) => {
  if (!value) return <span className='text-slate-300'>--/--/--</span>;

  const date = new Date(value);
  if (isNaN(date.getTime())) return value;

  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = date.getUTCFullYear();

  return `${day}-${month}-${year}`;
};
